module.exports = __webpack_public_path__ + "img/image.adb3e0f8.png";